import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Toggle from "../Toggle/Toggle";
import vision2030 from "../../img/vision-2030.png";
import { CLOUD_URL } from "../../seo/seoConfig";
import "./Navbar.css";

const Navbar = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isErp = location.pathname === "/erp";

  return (
    <div className="n-wrapper" id="Navbar">
      <div className="n-left">
        <RouterLink to="/" className="n-name n-brand-link">
          Litesoft
        </RouterLink>
        {isErp ? (
          <span className="n-vision" title="رؤية المملكة العربية السعودية 2030">
            <img
              src={vision2030}
              alt="رؤية المملكة 2030"
              className="n-vision-img"
            />
          </span>
        ) : null}
        <Toggle />
      </div>
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
            <li>
              <RouterLink to="/" className={isHome ? "active" : undefined}>
                الرئيسية
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/erp" className={isErp ? "active" : undefined}>
                حلول ERP
              </RouterLink>
            </li>
            <li>
              <a
                href={CLOUD_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                النظام السحابي
              </a>
            </li>
            {isHome ? (
              <>
                <li>
                  <ScrollLink to="services" spy={true} smooth={true}>
                    الخدمات
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="experience" spy={true} smooth={true}>
                    الخبرات
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="portfolio" spy={true} smooth={true}>
                    اعمال
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="testimonial" spy={true} smooth={true}>
                    عملائنا
                  </ScrollLink>
                </li>
              </>
            ) : (
              <>
                <li>
                  <ScrollLink to="erp-zatca" spy={true} smooth={true} offset={-40}>
                    الفوترة الإلكترونية
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="erp-modules" spy={true} smooth={true} offset={-40}>
                    الوحدات
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="erp-sectors" spy={true} smooth={true} offset={-40}>
                    القطاعات
                  </ScrollLink>
                </li>
                <li>
                  <ScrollLink to="erp-faq" spy={true} smooth={true} offset={-40}>
                    الأسئلة
                  </ScrollLink>
                </li>
              </>
            )}
          </ul>
        </div>
        <a
          className="button n-button"
          href={CLOUD_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          ابدأ مجاناً
        </a>
      </div>
    </div>
  );
};

export default Navbar;
